import useAuth from './useAuth';

const useCompany = () => {
  const { company, userCompany, isMultiCompany } = useAuth();

  return {
    company,
    isMultiCompany,
    userCompany
  };
};

export default useCompany;
